import { SVGProps } from "react";
const ArrowRedoLongPostSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.367 11.68h2.828V8.853"
    />
    <path
      stroke="#2A2D31"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.711 15.376a7.971 7.971 0 0 1 2.34-5.527 8 8 0 0 1 11.313 0 7.999 7.999 0 0 1 1.366 1.832"
    />
  </svg>
);
export default ArrowRedoLongPostSvg;
